module.exports = __webpack_public_path__ + "img/head1.72030920.jpg";